import { getRoleCapabilities, getRoleLabel, normalizeUserRole } from './rolePolicy.js';

// Provider boundary: accepts a password-session response or verified provider claims.
// Decoding an arbitrary JWT in the browser is not authentication.
export function normalizeUserIdentity(input = {}) {
  const role = normalizeUserRole(input.role);
  const familyId = String(input.familyId || input.family_id || '').trim();
  const assigned = input.assignedFamilyIds ?? input.customer_scope ?? input.customerScope ?? [];
  return {
    userId: String(input.userId || input.sub || '').trim(),
    userEmail: String(input.userEmail || input.email || '').trim(),
    userDisplayName: String(input.displayName || input.userName || input.name || input.userId || input.sub || '').trim(),
    roles: Array.isArray(input.roles) ? [...input.roles] : [input.role].filter(Boolean),
    familyScope: input.familyScope ?? input.customer_scope,
    paymentRoles: Array.isArray(input.roles) ? [...input.roles] : undefined,
    role, roleLabel: getRoleLabel(role),
    familyId,
    familyMemberId: String(input.familyMemberId || input.family_member_id || '').trim(),
    assignedFamilyIds: [...new Set((Array.isArray(assigned) ? assigned : []).map(String))],
    capabilities: getRoleCapabilities(role),
  };
}
